import React from "react";
import PropTypes from "prop-types";
import { useTheme, makeStyles } from "@material-ui/core/styles";
import {
  useMediaQuery,
  Grid,
  Typography,
  Box,
  Divider,
} from "@material-ui/core";
import { Button, Link } from "gatsby-theme-material-ui";
import { Video, Image } from "components/atoms";
import { SectionHeader } from "components/molecules";
import { HeroSideImage } from "components/organisms";

const useStyles = makeStyles((theme) => ({
  heroImage: {
    width: "100%",
    boxShadow: "rgba(50, 50, 50, 0.18) 0px 8px 24px",
  },
}));

const Hero = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"), {
    defaultMatches: true,
  });
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.up("sm"), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Typography
        variant={isSm ? "h3" : "h4"}
        align="left"
        color="textPrimary"
        gutterBottom
      >
        <Box fontWeight="bold" mt={7} mb={isMd ? 5 : 3}>
          Hi, I'm Ashu
        </Box>
      </Typography>

      <Image
        src="https://res.cloudinary.com/studiocollective/image/upload/v1740427971/Coaching%20Site/ideasdesai_ufxgvh.png"
        className={classes.heroImage}
      />
      <Typography component="div" variant="body1" gutterBottom>
        <Box component="p" mt={isMd ? 5 : 4} mb={3}>
          <b>
            I spent a decade building{" "}
            <Link
              to="/makeschool"
              color="inherit"
              style={{ textDecoration: "underline" }}
            >
              Make School
            </Link>
          </b>{" "}
          - a venture funded university that reached $10m annual revenue and
          served as a talent pipeline for high growth tech companies. My work
          centered around organizational design, systems building, and coaching
          our exec team.
        </Box>
        <Box component="p" mt={1} mb={3}>
          <b>
            I served as a visiting partner at{" "}
            <a href="https://www.ycombinator.com" target="_blank">
              Y Combinator
            </a>
          </b>{" "}
          studying what makes founders and organizations great across industries
          and geographies, coached several high growth startups over a longer
          period, and spent time with innovation centers inside Alphabet.
        </Box>
        <Box component="p" mt={1} mb={3}>
          I'm now building something new
        </Box>
      </Typography>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
